import { useContext, useEffect, useState } from 'react';
import Profile from '../assets/icons/profile/profile.png';
import ProfileLight from '../assets/icons/profile/profile_.png';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import { ThemeContext } from '../context/theme.context';
import Message from './Message/Message';
import { all_information, loadingShow } from '../App';
import {
  getAssignmentsDetails,
  setterTeamAndTradeToAssignment,
} from '../services/assignments/assignmentService';
import { GlobalMultiSelection } from '../components/GlobalDropDown';
import { MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
interface IProps {
  assignment_list: String[];
  hideDialogOrder: boolean;
  setHideDialogSetter: (cond: boolean) => void;
  affected: () => void;
}
var multipleAssignedInfo: any[] = [];
var teamTradesPersonalData: Array<any> = [];
var currentAssignment: any = [];
var dialog: DialogComponent = new DialogComponent({});
var teamMultiSelect: MultiSelectComponent = new MultiSelectComponent({});
var tradeMultiSelect: MultiSelectComponent = new MultiSelectComponent({});
const TeamAndTradeSetter = ({
  assignment_list,
  hideDialogOrder,
  setHideDialogSetter,
  affected,
}: IProps) => {
  const context = useContext(ThemeContext);
  const [currentImageUrl, setCurrentImageUrl] = useState('');
  const [selectedAssignmentName, setSelectedAssignmentName] = useState('');
  const [teamsMultiValue, setTeamsMultiValue] = useState<Array<any>>([]);
  const [tradesMultiValue, setTradesMultiValue] = useState<Array<any>>([]);
  const buttonsOrder: ButtonPropsModel[] = [
    {
      click: () => {
        saveSelectedTeamAndTrade();
      },
      buttonModel: {
        content: 'Apply',
        isPrimary: true,
      },
    },
    {
      click: () => {
        multipleAssignedInfo = []
        setHideDialogSetter(false);
      },
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];
  const getAssignment = async (id?: number) => {
    if (assignment_list.length == 1) {
      await getAssignmentsDetails(id)
        .then((response) => {
          loadingShow(false, 'Preparing...');
          teamTradesPersonalData.push(response.data[0].teams);
          teamTradesPersonalData.push(response.data[0].trades);
          setSelectedAssignmentName(response.data[0].alias_name);
          currentAssignment = response.data[0];
          const theTeamsData = teamTradesPersonalData[0].map(
            (e: any) => e.team_id
          );
          const theTradeData = teamTradesPersonalData[1].map(
            (e: any) => e.trade_id
          );
          setTradesMultiValue(theTradeData);
          setTeamsMultiValue(theTeamsData);
        })
        .catch((e: any) => {
          //(e);
          Message.error('Error occured.Please try again later');
          loadingShow(false, 'Preparing...');
        });
    } else {
      await getAssignmentsDetails(assignment_list.join(','))
        .then((response) => {
          response.data.map((eachObject: any) => {
            multipleAssignedInfo.push(eachObject);
          });
        })
        .catch((e: any) => {
          //(e);
          Message.error('Error occured.Please try again later');
          loadingShow(false, 'Preparing...');
        });
    }
  };
  const saveSelectedTeamAndTrade = () => {
    if (assignment_list.length == 1) {
      loadingShow(true, 'Processing...');
      const teamsData = teamsMultiValue.map((e) => {
        let theData: any = teamMultiSelect.getDataByValue(e);
        return {
          assignment_id: Number(assignment_list[0]),
          team_code: theData.team_code,
          team_id: theData.team_id,
          app: 'UWORK',
          user_id: all_information.user_id,
          organization_id: all_information.company_id?.toString(),
          creation_date: new Date(),
          created_by: all_information.user_id,
        };
      });
      const tradesData = tradesMultiValue.map((e) => {
        let theData: any = tradeMultiSelect.getDataByValue(e);
        return {
          assignment_id: Number(assignment_list[0]),
          trade_code: theData.trade_code,
          trade_id: theData.trade_id,
          app: 'UWORK',
          user_id: all_information.user_id,
          organization_id: all_information.company_id?.toString(),
          creation_date: new Date(),
          created_by: all_information.user_id,
        };
      });
      currentAssignment.teams = teamsData;
      currentAssignment.trades = tradesData;
      setterTeamAndTradeToAssignment(currentAssignment)
        .then((_response) => {
          loadingShow(false);
          setHideDialogSetter(false);
          //closed because after set a team and trade, this one send a get capacity request
          //affected();
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
          //(e);
        });
    } else {
      assignment_list.map((each, index) => {
        loadingShow(true, 'Processing...');
        const teamsData = teamsMultiValue.map((e) => {
          let theData: any = teamMultiSelect.getDataByValue(e);
          return {
            assignment_id: multipleAssignedInfo[index].assignment_id,
            team_code: theData.team_code,
            team_id: theData.team_id,
            app: 'UWORK',
            user_id: all_information.user_id,
            organization_id: all_information.company_id?.toString(),
            creation_date: new Date(),
            created_by: all_information.user_id,
          };
        });
        const tradesData = tradesMultiValue.map((e) => {
          let theData: any = tradeMultiSelect.getDataByValue(e);
          return {
            assignment_id: multipleAssignedInfo[index].assignment_id,
            trade_code: theData.trade_code,
            trade_id: theData.trade_id,
            app: 'UWORK',
            user_id: all_information.user_id,
            organization_id: all_information.company_id?.toString(),
            creation_date: new Date(),
            created_by: all_information.user_id,
          };
        });
        multipleAssignedInfo[index].teams = teamsData;
        multipleAssignedInfo[index].trades = tradesData;
      });
      setterTeamAndTradeToAssignment(multipleAssignedInfo)
        .then((_response) => {
          loadingShow(false);
          setHideDialogSetter(false);
          //closed because after set a team and trade, this one send a get capacity request
          //affected();
          multipleAssignedInfo = [];
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
          //(e);
        });
    }
  };

  useEffect(() => {
    dialog.content = setTeamTrades;
    dialog.refresh();
    return () => { };
  }, [tradesMultiValue, teamsMultiValue]);

  useEffect(() => {
    if (assignment_list.length == 1) {
      teamTradesPersonalData = [];
      const data = async () => {
        await getAssignment(Number(assignment_list[0]));
      };
      data();
      return () => { };
    } else {
      const data = async () => {
        await getAssignment(Number(assignment_list[0]));
      };
      data();
      loadingShow(false);
    }
  }, []);
  useEffect(() => {
    if (hideDialogOrder) {
      dialog.content = setTeamTrades;
      dialog.refresh();
    }
    return () => { };
  }, [hideDialogOrder]);

  const setTeamTrades = () => {
    return (
      <div>
        <div className='content-tradesTeamSetter'>
          <div className='conten-assign-image'>
            <img
              id='imgContent'
              src={
                currentImageUrl == ''
                  ? context.isDarkMode
                    ? ProfileLight
                    : Profile
                  : currentImageUrl
              }
              style={{
                height: '70px',
                width: '70px',
                backgroundColor: context.isDarkMode ? '#15202B' : ' white',
                borderRadius: 50,
              }}
            />
            <span style={{ marginTop: '10px' }}>
              {assignment_list.length == 1
                ? selectedAssignmentName
                : 'Selected TradePersons'}
            </span>
          </div>
          <div className='content-dropdownTeamTrade'>
            <div className='col-md-12' style={{ marginBottom: 40 }}>
              <GlobalMultiSelection
                field={{ value: 'team_id', text: 'team_code' }}
                refDD={(e: MultiSelectComponent) => (teamMultiSelect = e)}
                id='setter-team-filter'
                url='team'
                placeHolder='Select a Team'
                value={teamsMultiValue}
                onChange={(e: any) => {
                  setTeamsMultiValue(e.value);
                }}
                maximumSelectionLength={1}
                enablePersistence={false}
              />
            </div>
            <div className='col-md-12'>
              <GlobalMultiSelection
                refDD={(e: MultiSelectComponent) => (tradeMultiSelect = e)}
                field={{ value: 'trade_id', text: 'trade_code' }}
                id='setter-trade-filter'
                url='trade'
                placeHolder='Select Trades'
                value={tradesMultiValue}
                itemTemplate={(e: any) => (
                  <>{e.trade_code + ' - ' + e.description}</>
                )}
                onChange={(e: any) => {
                  setTradesMultiValue(e.value);
                }}
                maximumSelectionLength={2}
                enablePersistence={false}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <DialogComponent
      visible={hideDialogOrder}
      close={() => setHideDialogSetter(false)}
      open={() => setHideDialogSetter(true)}
      width={'400px'}
      height={'300px'}
      header='Set Team/Trade'
      buttons={buttonsOrder}
      isModal
      ref={(el: DialogComponent) => (dialog = el)}
      content={setTeamTrades}
    />
  );
};

export default TeamAndTradeSetter;
